import apiClient from '@/core/api/apiClient';
import type { 
  LoginRequest, 
  RefreshTokenRequest,
  RegisterRequest,
  LogoutRequest,
  AuthResponse,
  EmailVerificationParams,
  ResendVerificationParams,
  PasswordResetRequestParams,
  PasswordResetConfirmParams
} from '../types/authTypes';

export async function login(credentials: LoginRequest): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/login/', credentials);
  return data;
}

export async function refreshToken(refreshData: RefreshTokenRequest): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/token/refresh/', refreshData);
  return data;
}

export async function register(userData: RegisterRequest): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/register/', userData);
  return data;
}

export async function logout(logoutData: LogoutRequest): Promise<void> {
  await apiClient.post('/logout/', logoutData);
}

export async function verifyEmail({ uidb64, token }: EmailVerificationParams): Promise<void> {
  await apiClient.post(`/verify-email/${uidb64}/${token}/`);
}

export async function resendVerification({ email }: ResendVerificationParams): Promise<void> {
  await apiClient.post('/resend-verification/', { email });
}

export async function requestPasswordReset({ email }: PasswordResetRequestParams): Promise<void> {
  await apiClient.post('/password-reset/', { email });
}

export async function confirmPasswordReset({ 
  uidb64, 
  token, 
  password 
}: PasswordResetConfirmParams): Promise<void> {
  await apiClient.post(`/password-reset-confirm/${uidb64}/${token}/`, { password });
}